import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { Contact } from '../types/contact';

export function useCompanyContacts(companyId?: string) {
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchContacts() {
      if (!companyId) {
        setContacts([]);
        setLoading(false);
        return;
      }

      try {
        const { data, error: fetchError } = await supabase
          .from('nrm_contacts')
          .select('*')
          .eq('company_id', companyId)
          .order('last_name', { ascending: true });

        if (fetchError) throw fetchError;
        setContacts(data || []);
      } catch (err) {
        console.error('Failed to load company contacts:', err);
        setError('Unable to load contacts');
      } finally {
        setLoading(false);
      }
    }

    fetchContacts();
  }, [companyId]);

  return { contacts, loading, error };
}